import "./PageHeader.scoped.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import React, { useCallback, useEffect } from "react";
import Share from "../../Share/Share";
import {
  isLikeLoadingState,
  isOpenShareState,
  likeCountState,
  isMobileMatcheState,
  snsListState,
  userBoardLikeState,
  userInfoState,
  youtubeIdState,
  visibleState,
  connectSiteState,
  isPrivacyAgreeState,
  naverAuthorizeUrl,
  langCodeState
} from "../../../../atoms/atom";
import { useRecoilValue, useRecoilState, useSetRecoilState } from "recoil";
import { useQuery } from "react-query";
import {
  BASE_PATH,
  getLoungeInfo,
  ILoungeInfo,
  HeadersInfo
} from "../../../../api/api";
import {
  Service_CN,
  checkPosition,
  loginKey,
  msgRedirectURL,
  naverAuthorizePopUp,
  redirectURL
} from "../../../../utils/CommonFunc";
import PageMobileHeader from "./PageMobileHeader";
import axios from "axios";
import WrapLoading from "../../../common/loading/WrapLoading";
import {
  NAVER_SIGN_IN_URL,
  SIGN_IN_URL
} from "../../../../utils/config/Config";
import PageShortHeader from "./PageShortHeader";
import LoungeHelmet from "../../../common/LoungeHelmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faDesktop, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { useCookies } from "react-cookie";
import { isLauncherState, loginState } from "../../../../atoms/userInfoAtom";

function PageHeader() {
  const login = useRecoilValue(loginState);
  const userInfo = useRecoilValue(userInfoState);
  const visible = useRecoilValue(visibleState);
  const langCode = useRecoilValue(langCodeState);
  const len = visible ? "" : "short";
  const { service_code } = useParams();
  const { isLoading, data } = useQuery<ILoungeInfo>(["info", langCode], () =>
    getLoungeInfo(
      service_code || "",
      userInfo.Ssoinfo,
      userInfo.Userid,
      userInfo.Userbirth,
      userInfo.channelingType,
      langCode
    )
  );
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isOpenShare = useRecoilValue(isOpenShareState);
  const setIsOpenShare = useSetRecoilState(isOpenShareState);
  const [userBoardLike, setUserBoardLike] = useRecoilState(userBoardLikeState);
  const isMobile = useRecoilValue(isMobileMatcheState);
  const connectSite = useRecoilValue(connectSiteState);
  const isPrivacyAgree = useRecoilValue(isPrivacyAgreeState);
  const naverAuthorize = useRecoilValue(naverAuthorizeUrl);
  const isLauncher = useRecoilValue(isLauncherState);
  const [likeCount, setLikeCount] = useRecoilState(likeCountState);
  const [isLikeLoading, setIsLikeLoading] = useRecoilState(isLikeLoadingState);
  const setSnsList = useSetRecoilState(snsListState);
  const setYoutubeId = useSetRecoilState(youtubeIdState);
  const [, setCookie] = useCookies();

  useEffect(() => {
    if (data?.result === -99) {
      alert(data.msg);
    }
  }, []);

  useEffect(() => {
    if (data?.result === 1) {
      setLikeCount(data?.data.like_count);
      setSnsList(data?.data.sns);

      if (!Service_CN) {
        setCookie("service_code", data.data.service_code, {
          path: "/",
          domain: ".valofe.com"
        });
      }
    }
  }, [data]);

  useEffect(() => {
    if (data?.result === 1) {
      if (data.user_like_status === 0) {
        setUserBoardLike(false);
      } else {
        setUserBoardLike(true);
      }
    }
  }, [data?.user_like_status]);

  useEffect(() => {
    if (data?.result === 1) {
      setYoutubeId(data.data.youtube_id);
    }
  }, [data]);

  const getLikeBoard = async () => {
    if (login) {
      if (!isPrivacyAgree) {
        checkPosition();
        return naverAuthorizePopUp(naverAuthorize);
      }
    }
    // else {
    //   if (isLauncher) {
    //     window.app.vfunRequestLogin();
    //   } else {
    //     msgRedirectURL(
    //       t(loginKey),
    //       connectSite === "vfun"
    //         ? SIGN_IN_URL(service_code || "vfun")
    //         : NAVER_SIGN_IN_URL + service_code,
    //       "_self"
    //     );
    //   }
    // }
    if (isLikeLoading === false) {
      const api = `${BASE_PATH}/vfunlounge/${service_code}/like`;
      setIsLikeLoading(true);
      try {
        let res = await axios.post(
          api,
          {},
          HeadersInfo(
            userInfo.Ssoinfo,
            userInfo.Userid,
            userInfo.Userbirth,
            userInfo.channelingType,
            "application/json"
          )
        );
        setIsLikeLoading(false);
        if (res.data.result === 1) {
          if (res.data.data.status) {
            setUserBoardLike(true);
          } else {
            setUserBoardLike(false);
          }
          setLikeCount(res.data.data.like_count);
        } else if (res.data.result === -99) {
          if (isLauncher) {
            window.app.vfunRequestLogin();
          } else {
            msgRedirectURL(
              t(loginKey),
              connectSite === "vfun"
                ? SIGN_IN_URL(service_code || "vfun")
                : NAVER_SIGN_IN_URL + service_code,
              "_self"
            );
          }
        } else {
          alert(t("An_error_occured"));
        }
      } catch (error) {
        alert(t("An_error_occured"));
      }
    } else {
      // alert("처리 중");
    }
  };

  const LikeOnOff = userBoardLike ? "on" : "";
  const webUrl =
    data?.result === 1
      ? data?.data.pre_regist_url === null
        ? undefined
        : data?.data.pre_regist_url
      : undefined;

  const handleShare = useCallback(
    (e: React.MouseEvent) => {
      setIsOpenShare((isOpenShare) => !isOpenShare);
    },
    [isOpenShare]
  );

  return isLoading ? (
    <WrapLoading />
  ) : (
    <>
      {data?.result === 1 ? (
        // 풀버전과 모바일 버전
        !isMobile ? (
          // 풀버전에서 길 때와 짧을 때
          visible ? (
            <div
              className={`page-header ${len}`}
              style={{
                color: "black",
                backgroundImage: `url(${data?.data.top_background_image_url})`
              }}
            >
              <LoungeHelmet
                title={data?.data.title === null ? "" : data?.data.title}
              />
              <div className="row-w clearfix">
                <img
                  className="thumb-img"
                  src={data?.data.top_thumb_image_url}
                  alt={`${data?.data.service_code} thumb-img`}
                />
                <div className="header-cont">
                  <span className="gamename clearfix">
                    {data?.data.title}
                    <span className="btns-top f-right">
                      <a className="btns btn-pc" href={service_code}></a>
                      <span className="share-box btns">
                        <Link
                          className="btns btn-share"
                          to="#"
                          onClick={(e) => handleShare(e)}
                          title={t("share")}
                        />
                        <Share data={data} />
                      </span>
                    </span>
                  </span>
                  <span className="genre">
                    {/* <span className="fa fa-desktop" /> */}
                    <FontAwesomeIcon
                      icon={faDesktop as IconProp}
                      className="fadesktop"
                    />
                    {data?.data.genre}
                  </span>
                  <span className="age">
                    {data?.data.age === 0 ? "ALL" : `+${data?.data.age}`}
                  </span>

                  <span className="btns-bottom clearfix">
                    {/* HomePage Btn */}
                    {data.data.web_url === null ||
                    data.data.web_url === "" ? null : (
                      <Link
                        to="#"
                        className="btns"
                        onClick={(e) =>
                          redirectURL(data?.data.web_url, "_self", isLauncher)
                        }
                        title={t("homepage")}
                      >
                        <span className="icon home" />
                        {t("homepage")}
                        <span className="angle-right" />
                      </Link>
                    )}

                    {/* EventPage Btn */}
                    {data?.data.pre_regist_url === null ||
                    data?.data.pre_regist_url === "" ? null : (
                      <Link
                        to="#"
                        className="btns"
                        onClick={(e) =>
                          redirectURL(webUrl || "", "_self", isLauncher)
                        }
                        title={t("pre_reservation")}
                      >
                        <span className="icon gamepad" />
                        CBT {t("pre_reservation")}
                        <span className="angle-right" />
                      </Link>
                    )}

                    {/*  유저 라이크 + */}
                    <Link
                      to="#"
                      className={`btns thumb f-right ${LikeOnOff}`}
                      onClick={getLikeBoard}
                      title={t("like")}
                    >
                      <span className="icon thumb" />
                      <span className="txt">
                        {!isLikeLoading ? (
                          likeCount.toLocaleString()
                        ) : (
                          // <span className="fa fa-solid fa-circle-notch fa-spin" />
                          <FontAwesomeIcon
                            icon={faCircleNotch as IconProp}
                            spin
                          />
                        )}
                      </span>
                    </Link>
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <PageShortHeader
              data={data}
              LikeOnOff={LikeOnOff}
              getLikeBoard={getLikeBoard}
              len={len}
            />
          )
        ) : (
          <PageMobileHeader data={data} getLikeBoard={getLikeBoard} />
        )
      ) : (
        navigate("/notfound", { replace: true })
      )}
    </>
  );
}

export default React.memo(withTranslation()(PageHeader));
